export default __webpack_public_path__ + "static/media/shopmark.d67014dd.png";